import React, { useEffect, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';

const Reveal = ({ children, width="fit-content" }) => {
    const ref = useRef(null);
    // const isInView = useInView(ref, { triggerOnce: true });
    const isInView = useInView(ref, { triggerOnce: true });
    const mainControls = useAnimation();

    useEffect(() => {
        if(isInView) {
            mainControls.start('visible');
        }
    }, [isInView, mainControls]);

    return (
        <div ref={ref} className='p-5 w-full flex items-center justify-center'>
            <motion.div
                variants={{
                    hidden: {
                        opacity: 0,
                        y : 50,
                    },
                    visible: {
                        opacity: 1,
                        y : 0,
                    },
                }}
                initial= "hidden"
                animate= {mainControls}
                transition={{ duration: 0.5, delay: 0.25 }}
                className=' flex flex-wrap items-center justify-center w-full'
            >
                {children}
            </motion.div>
        </div>
    );
};

export default Reveal;
